<template >

  <div class="container " >
    <form action="" @submit.prevent="submit">
      <div class="card">
        <div class="card-header">
          <h6><i class="fa fa-address-book"></i><span class="tab-txt"> البيانات الاساسية </span></h6>
        </div>
        <div class="card-body">
          <div class="form row">
         
            <div class="form-group col-md-3">
              <label for="">الاسم الاول</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Fname.$model"
                :class="{
                  'is-invalid': $v.Fname.$error,
                  'is-valid': !$v.Fname.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Fname.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Fname.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Fname.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Fname.maxLength"
                  >اقصى عدد مسموح {{ $v.Fname.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">الاسم الثانى</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Sname.$model"
                :class="{
                  'is-invalid': $v.Sname.$error,
                  'is-valid': !$v.Sname.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Sname.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Sname.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Sname.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Sname.maxLength"
                  >اقصى عدد مسموح {{ $v.Sname.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">الاسم الثالث</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Tname.$model"
                :class="{
                  'is-invalid': $v.Tname.$error,
                  'is-valid': !$v.Tname.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Tname.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Tname.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Tname.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Tname.maxLength"
                  >اقصى عدد مسموح {{ $v.Tname.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">اللقب</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Ffname.$model"
                :class="{
                  'is-invalid': $v.Ffname.$error,
                  'is-valid': !$v.Ffname.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Ffname.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Ffname.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Ffname.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Ffname.maxLength"
                  >اقصى عدد مسموح {{ $v.Ffname.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="">النوع</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.Type.$model"
                :class="{
                  'is-invalid': $v.Type.$error,
                  'is-valid': !$v.Type.$invalid,
                }"
              >
                <option value="1">ذكر</option>
                <option value="2">انثى</option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.Type.required">هذا الحقل مطلوب</span>
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="">جوال الطالب</label>
              <input
                type="number"
                class="form-control"
                v-model.number.number="$v.mob.$model"
                :class="{
                  'is-invalid': $v.mob.$error,
                  'is-valid': !$v.mob.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.mob.between">لابد من إدخال رقم جوال صحيح</span>
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="">جوال ولى الامر</label>
              <input
                type="number"
                class="form-control"
                v-model.number.number="$v.mobFather.$model"
                :class="{
                  'is-invalid': $v.mobFather.$error,
                  'is-valid': !$v.mobFather.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.mobFather.between"
                  >لابد من إدخال رقم جوال صحيح</span
                >
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="">البريد الالكترونى</label>
              <input
                type="email"
                class="form-control"
                v-model.trim="$v.email.$model"
                :class="{
                  'is-invalid': $v.email.$error,
                  'is-valid': !$v.email.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.email.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.email.isUnique">صيغة الايميل غير مطابقة</span>
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="">المرحلة</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.Level_id.$model"
                :class="{
                  'is-invalid': $v.Level_id.$error,
                  'is-valid': !$v.Level_id.$invalid,
                }"
              >
             <option v-for="lev in levels" :value="lev.id" :key="lev.id">
           {{ lev.nLevel }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.Level_id.required">هذا الحقل مطلوب</span>
              </div>
            </div>

            <div class="form-group col-md-4">
              <label for="">الكلية / المدرسة</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.Collage_id.$model"
                :class="{
                  'is-invalid': $v.Collage_id.$error,
                  'is-valid': !$v.Collage_id.$invalid,
                }"
              >
            <option v-for="col in colleges" :value="col.id" :key="col.id">
           {{ col.collageName }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.Collage_id.required">هذا الحقل مطلوب</span>
              </div>
            </div>

            <div class="form-group col-md-6">
              <label for="">المدينة</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.city_id.$model"
                :class="{
                  'is-invalid': $v.city_id.$error,
                  'is-valid': !$v.city_id.$invalid,
                }"
              >
            <option v-for="city in cities" :value="city.id" :key="city.id">
           {{ city.cName }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.city_id.required">هذا الحقل مطلوب</span>
              </div>
            </div>

            <div class="form-group col-md-6">
              <label for="">الحى</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.district_id.$model"
                :class="{
                  'is-invalid': $v.district_id.$error,
                  'is-valid': !$v.district_id.$invalid,
                }"
              >
          <option v-for="dis in districts" :value="dis.id" :key="dis.id">
           {{ dis.dName }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.district_id.required">هذا الحقل مطلوب</span>
              </div>
            </div>

            <div class="form-group col-md-6">
              <label for="">العنوان</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.addressFather.$model"
                :class="{
                  'is-invalid': $v.addressFather.$error,
                  'is-valid': !$v.addressFather.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.addressFather.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.addressFather.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.addressFather.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.addressFather.maxLength"
                  >اقصى عدد مسموح
                  {{ $v.addressFather.$params.maxLength.max }}</span
                >
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="">الموقع</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Location.$model"
                :class="{
                  'is-invalid': $v.Location.$error,
                  'is-valid': !$v.Location.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Location.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Location.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Location.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Location.maxLength"
                  >اقصى عدد مسموح {{ $v.Location.$params.maxLength.max }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
            <h6><i class="fa fa-database"></i><span class="tab-txt"> بيانات التعاقد </span></h6>
        </div>
        <div class="card-body">
          <div class="form row">
            <div class="form-group col-md-6">
              <label for="">كود الباص</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.busCode.$model"
                :class="{
                  'is-invalid': $v.busCode.$error,
                  'is-valid': !$v.busCode.$invalid,
                }"
              >
               <option v-for="bus in buses" :value="bus.id" :key="bus.id">{{bus.id}}</option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.busCode.required">هذا الحقل مطلوب</span>
              </div>
            </div>
<div class="form-group col-md-6">
              <label for="">قيمة الاشتراك</label>

              <input
                type="text"
                class="form-control"
                v-model.trim="$v.AmountSub.$model"
                :class="{
                  'is-invalid': $v.AmountSub.$error,
                  'is-valid': !$v.AmountSub.$invalid,
                }"
              />

              <div class="invalid-feedback">
                <span v-if="!$v.AmountSub.required">هذا الحقل مطلوب</span>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="">نوع التعاقد</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.contractType_id.$model"
                :class="{
                  'is-invalid': $v.contractType_id.$error,
                  'is-valid': !$v.contractType_id.$invalid,
                }"
              >
                <option value="1">ترم كامل</option>
                <option value="2">نصف ترم</option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.contractType_id.required">هذا الحقل مطلوب</span>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="">نوع الخدمة</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.transfareType_id.$model"
                :class="{
                  'is-invalid': $v.transfareType_id.$error,
                  'is-valid': !$v.transfareType_id.$invalid,
                }"
              >
                <option value="1"> ذهاب وعودة</option>
                <option value="2">ذهاب فقط</option>
                <option value="3">عودة فقط</option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.transfareType_id.required"
                  >هذا الحقل مطلوب</span
                >
              </div>
            </div>
      <div class="form-group col-md-6 ">
              <label for="">الفصل الدراسى</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.classyears.$model"
                :class="{
                  'is-invalid': $v.classyears.$error,
                  'is-valid': !$v.classyears.$invalid,
                }"
              >
          <option v-for="cls in classY" :value="cls.id" :key="cls.id">
            <span> {{ cls.classs }} </span>
           <span> {{ cls.classyear }} </span>
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.classyears.required">هذا الحقل مطلوب</span>
              </div>
            </div>
                  <div class="form-group col-md-6 ">
              <label for="">الفرع</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.branch.$model"
                :class="{
                  'is-invalid': $v.branch.$error,
                  'is-valid': !$v.branch.$invalid,
                }"
              >
          <option v-for="cls in branches" :value="cls.id" :key="cls.id">
            <span> {{ cls.branchName }} </span>
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.branch.required">هذا الحقل مطلوب</span>
              </div>
            </div>
  <div class="form-group col-md-6">
              <label for="">بداية الاشتراك</label>
             
              <input
                id="startSub"
                type="text"
                @blur="firedatest"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.startSub.$model"
                :class="{
                  'is-invalid': $v.startSub.$error,
                  'is-valid': !$v.startSub.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.startSub.required">هذا الحقل مطلوب</span>
              </div>
            </div>

            <div class="form-group col-md-6">
              <label for="">نهاية الاشتراك</label>
              <input
                id="endSub"
                @blur="firedateed"
                type="text"
                class="form-control hijri-date-input"
                v-bind:value="$v.endSub.$model"
                :class="{
                  'is-invalid': $v.endSub.$error,
                  'is-valid': !$v.endSub.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.endSub.required">هذا الحقل مطلوب</span>
              </div>
            </div>
          
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h6><i class="fa fa-cog"></i><span class="tab-txt"> التحكم </span></h6>
          </div>
          <div class="card-body">
            <div class="form row">
              <button
                class="btn btn-success"
                type="submit"
                :disabled="submitStatus === 'انتظار'"
              >
              <b-spinner
v-if="busy"
small
type="grow"
style="margin-bottom: 3px;"
></b-spinner>
              <i class="fa fa-paper-plane"></i>
               <span> {{submitStatus}} </span>
              </button>
               <b-button
                class="btn btn-info mr-3"
                type="button"
                to="/students"
              >
              <i class="fa fa-undo"></i>
               <span> عودة </span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>





<script>
  import { mapState,mapActions,mapGetters  } from 'vuex';
 import $ from 'jquery'
import indexLayout from "../../layouts/indexLayout.vue";


import {
  required,
  minLength,
  maxLength,
  email,
  between,
} from "vuelidate/lib/validators";
export default {
  name: "createStd",
  data() {
    return {
      
      Fname: "",
      Sname: "",
      Tname: "",
      Ffname: "",
      Level_id: "",
      Collage_id: "",
      addressFather: "",
      classyears: "",
      mob: 0,
      mobFather: 0,
      branch: "",
      email: "",
      Type: "",
      busCode: "",
      startSub: "",
      endSub: "",
      AmountSub: "",
      contractType_id: "",
      transfareType_id: "",
      city_id: "",
      district_id: "",
      Location: "",
      classyear: "",
      busy:false,
      submitStatus: "حفظ",
    };
  },
  validations: {
    
    Fname: { required, minLength: minLength(2), maxLength: maxLength(15) },
    Sname: { required, minLength: minLength(2), maxLength: maxLength(15) },
    Tname: { required, minLength: minLength(2), maxLength: maxLength(15) },
    Ffname: { required, minLength: minLength(2), maxLength: maxLength(15) },
    Level_id: { required },
    Collage_id: { required },
    addressFather: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(250),
    },
    mob: { required, between: between(100000000, 100000000000) },
    mobFather: { required, between: between(100000000, 100000000000) },
    email: {
      email,
      isUnique(value) {
        if (value === "") return true;
        var email_regx = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
      },
    },
    Type: { required },
    branch: { required },
    busCode: { required },
    classyears:{ required },
    AmountSub: { required },
    contractType_id: { required },
    transfareType_id: { required },
    city_id: { required },
    district_id: { required },
    Location: { required, minLength: minLength(1), maxLength: maxLength(15) },
    startSub: { required,
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    },
    endSub: { required,
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    } },
  },
  methods: {
   ...mapActions('stdMod',['addStudents']),
  firedatest(){
        var st = $('#startSub').val();
        this.startSub = st;
   },  firedateed(){
        var ed = $('#endSub').val();
        this.endSub = ed;
   },
   async submit() {
      this.$v.$touch();
      this.busy=true;
      if (this.$v.$invalid) {
        this.submitStatus = "خطأ";
        this.busy=false;
      } else {
       var std = {
        Fname: this.Fname,
        Sname: this.Sname,
        Tname: this.Tname,
        Ffname: this.Ffname,
        Level_id: this.Level_id,
        Collage_id: this.Collage_id,
        addressFather: this.addressFather,
        mob: this.mob,
        mobFather: this.mobFather,
        branch: this.branch,
        email: this.email,
        Type: this.Type,
        busCode: this.busCode,
        startSub: this.startSub,
        endSub: this.endSub,
        AmountSub: this.AmountSub,
        contractType_id: this.contractType_id,
        transfareType_id: this.transfareType_id,
        city_id: this.city_id,
        district_id: this.district_id,
        Street: this.Street,
        classyears: this.classyears,
        Location: this.Location
}
         await  this.addStudents(std);       

        this.submitStatus = "الانتظار";
        setTimeout(() => {
          this.submitStatus = "تم الحفظ";
        }, 500);
        this.busy=false;
      }
    },
  },created(){

let ckeditor = document.createElement('script'); 
//ckeditor.setAttribute('src',"/load.js");
ckeditor.innerHTML = "$(function () { initHijrDatePicker();  });";
document.head.appendChild(ckeditor);
 this.$emit('update:layout',indexLayout);


  }
  ,mounted(){
    
  
  },
  computed:{
  ...mapState([
    'cities',
    'districts',
    'colleges',
    'levels',
    'buses',
    'students'
  ]),
      ...mapGetters({
      classY: "classesMod/GET_ALLDATA",
       branches: "branchMod/GET_ALLDATA",
    }),
}};
</script>

<style lang="scss" scoped>
span{
  font-size: 12px;
}
</style>
